export async function getClient() {
  try {
    let response = await fetch(`/conta/cliente`, {
      headers: {
        accept: 'application/json'
      }
    });
    let client = await response.json();

    if (Object.keys(client).length > 0) {
      return client
    } else {
      return {}
    }

  } catch (error) { console.error(`getClient error`, error) }
}

// ===============================================================
// FORMAT MONEY
// ===============================================================
export function formatMoney(value) {
  // FORMATA UM VALOR
  return (
    'R$ ' +
    value
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+\,)/g, '$1.')
  );
}
